import React from 'react';
import {injectIntl} from 'react-intl';

const InvalidLocation = ({intl}) => {
  return (
    <>
      <div className="block block--s">
        <div className="block__wrapper wrapper">
          <div className="block__header">
            <h2 className="block__title">{intl.formatMessage({id: 'InvalidLocation.Title'})}</h2>
          </div>
          <div className="block__content block__content--xs body-copy color-preset--turquoise">
            <p> {intl.formatMessage({id: 'InvalidLocation.Body'})}</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default injectIntl(InvalidLocation);
